import { isValidTimeStamp } from 'utils/dateUtils';

/**
 * filters notifications by type
 * @param {string[]} filteredBy
 * @param {array} notifications
 * @returns {array} filtered array
 */
export const filterNotificationsByTypes = (filteredBy, notifications) =>
  notifications.filter((notification) => filteredBy.includes(notification.type?.slice(0, 3)?.toLowerCase()));

/**
 * map over array of items and updates single item status
 * @param {string} eventId
 * @param {string} status
 * @param {array} items
 * @returns {array} new array with updated item
 */
export const mapListOfItemsAndUpdateItemStatusById = (eventId, status, items) => {
  return items.map((item) => {
    if (!item.eventId === eventId) return item;
    const newItem = { ...item };
    newItem.event_status = status;
    return newItem;
  });
};

/**
 * map on selected items
 * @param {string} id
 * @param {string[]} selectedItems
 * @returns {array} new mapped array
 */
export const mapSelectedItems = (id, selectedItems) => {
  const isExist = selectedItems.includes(id);
  return isExist ? selectedItems.filter((i) => i !== id) : [...selectedItems, id];
};

/**
 * dismiss notifications
 * @param {string[]} ids
 * @param {array} notifications
 * @returns {array} filtred array
 */
export const removeNotificationsFromList = (ids, notifications) => {
  return notifications.filter(({ eventId }) => !ids.includes(eventId));
};

/**
 * replaces invalid timestamps
 * @param {array} array
 * @returns {array} modified array
 */
export const replaceInvalidTimestamps = (array) => {
  return array.map((item) => (isValidTimeStamp(item.timestamp) ? item : { ...item, timestamp: new Date().getTime() }));
};

/**
 * Creates from array of elements another array of arrays of elements with specified length
 * @param {array} array
 * @param {number} itemsCount
 * @returns {array} new array of arrays
 */
export const sliceArrayByItemsCount = (array = [], itemsCount) => {
  if (!array.length) return [];
  if (!itemsCount) return [array];
  const newArray = [];
  const length = Math.ceil(array.length / itemsCount);
  for (let i = 0; i < length; i += 1) {
    newArray.push(array.slice(itemsCount * i, itemsCount * i + itemsCount));
  }
  return newArray;
};

export const mapProductDataForShare = (productData, config, userBrand) => {
  const { name, designer, media, metadata, skus, price, id, details } = productData;
  return {
    description: name,
    designerName: designer?.name,
    imageUrl: media?.main?.medium?.url,
    pimStyle: metadata?.pimStyle,
    pimSkuId: skus?.[0]?.metadata?.pimSkuId,
    price: price?.currencyCode + price?.retailPrice,
    productId: id,
    sharedProductLink: `${config.get(`links.${userBrand}`)}${details?.canonicalUrl}`,
    skuId: skus?.[0]?.id,
    thumbnailUrl: media?.main?.thumbnail?.url,
    fromSku: true,
  };
};
